(function () {
  "use strict";

  function initFeaturedProduct() {
    const section = document.querySelector(".blueLightProduct");
    if (!section) return;

    section.querySelectorAll(".single-option-selector").forEach((select) => {
      select.addEventListener("change", () => {
        const selected = select.options[select.selectedIndex];
        const price = selected.getAttribute("data-price");
        const btn = select.closest(".product-single__form")?.querySelector(".add-to-cart span");
        if (btn && price) btn.textContent = "Add to Cart | " + price;
      });
    });

    section.querySelectorAll(".quantitySelectorAdjust.quantitySelectorMinus").forEach((btn) => {
      btn.addEventListener("click", () => {
        const input = btn.closest(".quantitySelector")?.querySelector(".quantitySelectorNum");
        if (!input) return;
        const val = parseInt(input.value, 10);
        if (val > 1) input.value = String(val - 1);
      });
    });

    section.querySelectorAll(".quantitySelectorAdjust.quantitySelectorPlus").forEach((btn) => {
      btn.addEventListener("click", () => {
        const input = btn.closest(".quantitySelector")?.querySelector(".quantitySelectorNum");
        if (!input) return;
        input.value = String(parseInt(input.value, 10) + 1);
      });
    });

    section.querySelectorAll(".add-to-cart").forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        const form = btn.closest(".product-single__form");
        if (!form) return;

        const selected = form.querySelector(".single-option-selector option:checked");
        const variantId = selected?.dataset.id;
        const qtyInput = form.querySelector(".quantitySelectorNum");
        const quantity = parseInt(qtyInput?.value, 10);

        if (!variantId || isNaN(quantity) || quantity <= 0) return;

        theme.blueLightCart
          .addToCart(variantId, quantity)
          .then((data) => {
            if (data.status !== 422) theme.blueLightCart.openCartAfterAdd(data);
          })
          .catch(console.error);
      });
    });
  }

  function initChooseDevice() {
    const section = document.querySelector(".mainChooseDevice");
    if (!section) return;

    function updatePriceOnButton(selectedOption, block) {
      const price = selectedOption.dataset.price;
      const wrapper = block.querySelector(".money-wrapperr");
      if (wrapper && price) wrapper.textContent = "| " + price;
    }

    function updateSelectedAttribute(block) {
      const selected = block.querySelector(".single-option-selector option:checked");
      if (!selected) return;
      const variantId = selected.dataset.id;
      block.querySelectorAll(".single-option-selector option").forEach((opt) => {
        opt.removeAttribute("selected");
      });
      const match = block.querySelector(
        '.single-option-selector option[data-id="' + variantId + '"]'
      );
      if (match) match.setAttribute("selected", "selected");
    }

    section.querySelectorAll(".single-option-selector").forEach((select) => {
      select.addEventListener("change", () => {
        const selected = select.options[select.selectedIndex];
        updatePriceOnButton(selected, select.closest(".block-product"));
        select.querySelectorAll("option").forEach((o) => o.removeAttribute("selected"));
        selected.setAttribute("selected", "selected");
      });
    });

    section.querySelectorAll(".add-to-cart").forEach((btn) => {
      btn.addEventListener("click", () => {
        const block = btn.closest(".block-product");
        const selected = block?.querySelector(".single-option-selector option:checked");
        if (!selected || selected.classList.contains("default-variant")) return;
        const variantId = selected.dataset.id;
        if (!variantId) return;
        theme.blueLightCart.addToCart(variantId, 1).catch(console.error);
      });
    });

    section.querySelectorAll(".block-product").forEach(updateSelectedAttribute);
  }

  function initEyeProducts() {
    const section = document.querySelector(".eyeProductsSec");
    if (!section) return;

    section.querySelectorAll(".eyeProductsSecform .add-to-cart").forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        const form = btn.closest("form");
        if (!form) return;
        theme.blueLightCart
          .addToCartFromForm(form)
          .then((data) => {
            if (data.status !== 422) theme.blueLightCart.openCartAfterAdd(data);
          })
          .catch(console.error);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initFeaturedProduct();
    initChooseDevice();
    initEyeProducts();
  });
})();
